import React from 'react'
import {
    Tooltip, Alert, AlertColor, Avatar, Button, ButtonGroup, Checkbox, Snackbar,
} from "@mui/material";
import BTPersonReport from "../../shared/_BTPersonReport";
import {
    ColumnDirective,
    ColumnsDirective,
    ColumnMenu,
    GridComponent,
    Grid,
    Inject,
    Page,
    Sort,
    Filter,
    DetailRow,
    ExcelExport,
    PdfExport,
    Toolbar,
    Search, ExcelExportProperties,
    Resize, Reorder, SortSettingsModel, Column
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-navigations';
import GeoCode from "../../shared/GeoCodes/_GeoCode_Display";
import MapIcon from "@mui/icons-material/Map";
import Geocode from "react-geocode";
import {Google_API_Key, SiteName} from '../../../services/config.service';
import { formatDate } from '../../../services/formatDate.service';
import { JAOS } from '../../../services/JAOS.service';
import NCICIcon from '../../../assets/Images/NCIC.png';
import { isNCICShow } from '../../../services/auth.service';
import BTPersonIndicatorGrid from "../../shared/_PersonIndicators";
import {getValue} from "@syncfusion/ej2-base";
import {GetStringNameForSite} from "../../../interfaces/config.interface";


interface SearchResultsProps {
    Persons: any[]
    showPlate?: boolean,
    hideJail?: boolean
}

const SearchResults: React.FC<SearchResultsProps> = ({Persons, showPlate=false, hideJail=false})=> {
    const [typedPersons, setTypedPersons] = React.useState<any[]>([])
    const [showGeoCode, setShowGeoCode] = React.useState(false)
    const [allPins, setAllPins] = React.useState<any[]>([])
    //Alerts
    const [alertOpen, setAlertOpen] = React.useState<boolean>(false)
    const [alertText, setAlertText] = React.useState<string>("")
    const [alertType, setAlertType] = React.useState<AlertColor>("error")
    const [ncicList, setNCICList] = React.useState<any[]>([])

    Geocode.setApiKey(Google_API_Key);
    let grid: Grid | null;
    let selectedRows: any[] = [];

    const handleDataTyping = () =>
    {
        if (Persons) {
            let tempP: any = [...Persons]
            if(hideJail)
            {
                tempP = tempP.filter((e:any) => e.FoundJail !== 2)
            }
            //reset NCIClist if they search again
            setNCICList([])
            for (let p of tempP) {
                if (p.DOB) {
                    p.DOB = new Date(p.DOB)
                }
                if (p.DTOFARREST) {
                    p.DTOFARREST = new Date(p.DTOFARREST)
                }
                if (p.DTOFUPDATE) {
                    p.DTOFUPDATE = new Date(p.DTOFUPDATE)
                }
                if (p.PercentileDate) {
                    p.PercentileDate = new Date(p.PercentileDate)
                }
            }
            setTypedPersons(tempP)
        }
        
    }

    React.useEffect(() => {
        handleDataTyping()
    }, [Persons, hideJail])

    /*React.useEffect(() => {
        handleJail()
    }, [hideJail])*/
    
    /*const handleJail = () => {
        if (grid) {
            console.log(grid)
            let temp:any = grid?.dataSource
            console.log(temp)
            temp = temp.filter((e:any) => e.FoundJail !== 2)
            grid.dataSource = temp
        }
    }*/

    const gridTemplate = (person: any): any => {
        return (
            <BTPersonIndicatorGrid person={person} />
        );
    }

    const getPersonSummary = (p:any) =>
    {
        return (<div><BTPersonReport person={p}/></div>)
    }

    const GridToolsClick = (args: ClickEventArgs) => {
        
        if (grid && args.item.text === "Excel Export") {
            
            let excelProp:ExcelExportProperties = {}
            excelProp.fileName = 'SCOR.xlsx';

            (grid.getColumnByField("FBI") as Column).visible = true;
            (grid.getColumnByField("SBINo") as Column).visible = true;
            (grid.getColumnByField("SSN1") as Column).visible = true;
            (grid.getColumnByField("FBI") as Column).visible = true;
            (grid.getColumnByField("SBINo") as Column).visible = true;
            (grid.getColumnByField("SSN1") as Column).visible = true;
            (grid.getColumnByField("FoundPhoto") as Column).visible = true;
            (grid.getColumnByField("FoundArrest") as Column).visible = true;
            (grid.getColumnByField("FoundETicket") as Column).visible = true;
            (grid.getColumnByField("FoundParkMobile") as Column).visible = true;
            (grid.getColumnByField("FoundALPR") as Column).visible = true;
            (grid.getColumnByField("FoundCADRMS") as Column).visible = true;
            (grid.getColumnByField("FoundCODIS") as Column).visible = true;
            (grid.getColumnByField("FoundPrisonRelease") as Column).visible = true;
            (grid.getColumnByField("FoundGunTrace") as Column).visible = true;
            (grid.getColumnByField("FoundShooting") as Column).visible = true;
            (grid.getColumnByField("FoundNIBIN") as Column).visible = true;
            (grid.getColumnByField("FoundNJGunTrace") as Column).visible = true;
            (grid.getColumnByField("FoundPrisonParole") as Column).visible = true;
            (grid.getColumnByField("FoundArrest") as Column).visible = true;
            (grid.getColumnByField("FoundViolent") as Column).visible = true;
            (grid.getColumnByField("FoundHumanTraffic") as Column).visible = true;
            (grid.getColumnByField("FoundProfession") as Column).visible = true;
            (grid.getColumnByField("FoundReferral") as Column).visible = true;
            (grid.getColumnByField("FoundProfile") as Column).visible = true;
            (grid.getColumnByField("FoundDomViolence") as Column).visible = true;
            (grid.getColumnByField("FoundSexCrime") as Column).visible = true;
            (grid.getColumnByField("FoundCarTheft") as Column).visible = true;
            (grid.getColumnByField("FoundJail") as Column).visible = true;

            grid.excelExport(excelProp);
            
        }else if (grid && args.item.text === 'PDF Export') {
            grid.pdfExport();
        }
        else if (grid && args.item.text === 'Clear Selected'){
            grid.clearSelection()
            selectedRows=[]
            
        }
    }

    const excelExportComplete = () => {
        if (grid) {
            (grid.getColumnByField("FBI") as Column).visible = false;
            (grid.getColumnByField("SBINo") as Column).visible = false;
            (grid.getColumnByField("SSN1") as Column).visible = false;
            (grid.getColumnByField("FBI") as Column).visible = false;
            (grid.getColumnByField("SBINo") as Column).visible = false;
            (grid.getColumnByField("SSN1") as Column).visible = false;
            (grid.getColumnByField("FoundPhoto") as Column).visible = false;
            (grid.getColumnByField("FoundArrest") as Column).visible = false;
            (grid.getColumnByField("FoundETicket") as Column).visible = false;
            (grid.getColumnByField("FoundParkMobile") as Column).visible = false;
            (grid.getColumnByField("FoundALPR") as Column).visible = false;
            (grid.getColumnByField("FoundCADRMS") as Column).visible = false;
            (grid.getColumnByField("FoundCODIS") as Column).visible = false;
            (grid.getColumnByField("FoundPrisonRelease") as Column).visible = false;
            (grid.getColumnByField("FoundGunTrace") as Column).visible = false;
            (grid.getColumnByField("FoundShooting") as Column).visible = false;
            (grid.getColumnByField("FoundNIBIN") as Column).visible = false;
            (grid.getColumnByField("FoundNJGunTrace") as Column).visible = false;
            (grid.getColumnByField("FoundPrisonParole") as Column).visible = false;
            (grid.getColumnByField("FoundArrest") as Column).visible = false;
            (grid.getColumnByField("FoundViolent") as Column).visible = false;
            (grid.getColumnByField("FoundHumanTraffic") as Column).visible = false;
            (grid.getColumnByField("FoundProfession") as Column).visible = false;
            (grid.getColumnByField("FoundReferral") as Column).visible = false;
            (grid.getColumnByField("FoundProfile") as Column).visible = false;
            (grid.getColumnByField("FoundDomViolence") as Column).visible = false;
            (grid.getColumnByField("FoundSexCrime") as Column).visible = false;
            (grid.getColumnByField("FoundCarTheft") as Column).visible = false;
            (grid.getColumnByField("FoundJail") as Column).visible = false;
        }
    }
    
    const openGeoCode = () => {
        let pins:any[] = []
        for (let p of Persons)
        {
            if(p.Address_Lat && p.Address_Lon )
            {
                let pName = p.FName?.toUpperCase() + " " + (p.MName?.toUpperCase() ? p.MName?.toUpperCase() : "")  + " " + p.LName?.toUpperCase()
                pins.push({lat:p.Address_Lat, lng:p.Address_Lon, name:pName, arrestCount:p.CrumbScorePercentile?.toFixed(0), crumbScoreDate:formatDate(p.ScoreDate), crumbPercentile:p.CrumbScorePercentile, crumbScore:p.CrumbScore, tool:"crumb"})
            }
        }
        setAllPins(pins)
        setShowGeoCode(true)
    }

    const HandleGeoCodeClose = () => {
        setShowGeoCode(false)
    }

    const dataBound = () => {
        if(grid){
            grid.autoFitColumns([])
        }
    }
    
    let sortSettings: SortSettingsModel = { columns: [
            {field: 'CrumbScorePercentile', direction: 'Ascending' }
    ]
    };

    const expandRow = (args: any) => {
        let rows = [...selectedRows];
        //expand if a row is selected except select checkbox
        //     if(args?.name === 'rowSelected' && args?.target.ariaLabel != null || args?.target.alt){
        //         if(grid){
        //             const selectedrowindex= grid.getSelectedRowIndexes()
        //             for (let idx of selectedrowindex) {
        //                 grid.detailRowModule.expand(idx)
        //             }
        //         }
        
        //     }
        if (args?.isHeaderCheckboxClicked){
            rows = [];
            for (let idx = 0; idx < typedPersons.length; idx++) {
                let person: any = typedPersons[idx];
                if (person && person.PersonID) {
                    rows.push(person)
                }
            }
        }
        else {
            if  (args?.data && args?.data?.length !== typedPersons.length) {
                var result = rows.findIndex(x => x.PersonID === args?.data.PersonID)
                if (result === -1) {
                    let person = args?.data;
                    if (person && person.PersonID) {
                        rows.push(person)
                    }
                }
                else {
                    rows.splice(result,1)
                }
            }
        }
        selectedRows=rows
    }     
    
    

    const rowDeselect = (args: any) => {
        let rows = [...selectedRows];
        // if(args?.name === 'rowDeselected'){
        //     if(grid){
        //         grid.detailRowModule.collapseAll()
        //     }       
        // }
        if(args?.isHeaderCheckboxClicked){
            rows= [];
        }
        else {
            if (args?.data && args?.data?.length !== typedPersons.length) {
                var result = rows.findIndex(x => x.TableID === args?.data.TableID && x.TableType === args?.data.TableType)

                if (result === -1) {
                    let person = args?.data;
                    if (person && person.PersonID) {
                        rows.push(person)
                    }
                }
                else {
                    rows.splice(result, 1)
                }
            }
        }
        selectedRows = rows;
    }

    // const selectTemplate = (person: any): any => {
    //     return (
    //     <>
    //         <Checkbox onClick={ () => {buildNCICList(person)} }/>
    //     </>);
    // }
    // const buildNCICList = (person:any) => {
    //     //let rows = selectedRows
    //     let NCICListTemp = ncicList
    //     var result = NCICListTemp.findIndex(x => x.PersonID === person?.PersonID)
        
    //     if (result === -1) {
    //         NCICListTemp.push(person)
    //     }
    //     else {
    //         NCICListTemp.splice(result, 1)
    //     }
    //     setNCICList(NCICListTemp)       
    // } 

    const handleNCICSearch = () => {
        let tempSelectedRows = []
        for(let idx in selectedRows){
            tempSelectedRows.push({
                PersonID: selectedRows[idx].PersonID,
                TableID: selectedRows[idx].TableID,
                DLNo: selectedRows[idx].DLNo,
                FName: selectedRows[idx].FName,
                MName: selectedRows[idx].MName,
                LName: selectedRows[idx].LName,
                DOB: selectedRows[idx].DOB,
                FBI: selectedRows[idx].FBI,
                SBINo: selectedRows[idx].SBINo,
            })
        }
        if (tempSelectedRows.length > 0 && tempSelectedRows.length < 14001) {
            let l = new JAOS()
            let hashID = l.objToStack(tempSelectedRows);
            window.open('/tools/ncic_multiple_occurrence?person=' + hashID, '_blank')
        }
        else if (tempSelectedRows.length >= 14001){
            setAlertType("error");
            setAlertText("Please reduce selection size to 14000 to run NCIC search");
            setAlertOpen(true);
            grid?.clearSelection()
        }    
        else {
            setAlertType("error");
            setAlertText("Please select at least one offender to run NCIC search");
            setAlertOpen(true);
        }
        
    }

    const toolbarOptions: object[] = [
        {text:"Excel Export" , prefixIcon:"e-excelexport", tooltipText:"Excel Export",type: "Button",}, {text:"Search"}, {text:"Clear Selected", prefixIcon: "e-collapse-2", tooltipText:"Clear Selected", type: "Button"}
    ]
    
    return (
        <div className={"pl-10 pr-10 mt-5"}>
            {typedPersons && typedPersons.length>0? <>
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={alertOpen} autoHideDuration={6000} onClose={() => { setAlertOpen(false) }}>
                    <Alert onClose={() => { setAlertOpen(false) }} severity={alertType} sx={{ width: '100%' }}>
                        {alertText}
                    </Alert>
                </Snackbar>
                <span style={{ display: "inline-block" }} className='mb-5'>
                    <h4 className={"font-bold inline mr-5 text-lg"}> {typedPersons?.length} Records Found</h4>
                    <ButtonGroup size="medium" color="inherit" className='mb-2 mr-2'>
                         <Button variant="outlined" onClick={openGeoCode}>
                            <MapIcon color="success" className ="mr-2"/><b>Map</b>
                        </Button>
                    </ButtonGroup>
                    {(showGeoCode) ? <div><GeoCode HandleGeoCodeClose={HandleGeoCodeClose} show={showGeoCode} pins={allPins} mapVersion={'1'} /></div> : <></>}
                    {isNCICShow() ?
                        <ButtonGroup size="medium" color="inherit" className='mb-2 mr-2'>
                            <Tooltip title="Search NCIC Warrant Deatils for Select Offender(s)" placement="top" arrow>
                                <Button variant="outlined" onClick={handleNCICSearch}>
                                    <img src={NCICIcon} className={"mr-2"} alt={""} />NCIC Search
                                </Button>
                            </Tooltip>
                        </ButtonGroup> : <></>
                    }
                </span>
                <GridComponent
                    dataSource={typedPersons}
                    dataBound={dataBound}
                    allowPaging={true}
                    pageSettings={{pageSize: 25, pageSizes: [10,25,50,100]}}
                    allowSorting={true}
                    sortSettings={sortSettings}
                    allowMultiSorting={true}
                    allowFiltering={true}
                    filterSettings={{type: 'CheckBox'}}
                    detailTemplate={getPersonSummary}
                    allowTextWrap={true}
                    textWrapSettings={{ wrapMode: 'Both' }}
                    allowExcelExport={true}
                    allowPdfExport={true}
                    toolbar={toolbarOptions}
                    //toolbar={['ExcelExport','Search']}
                    toolbarClick={GridToolsClick}
                    excelExportComplete={excelExportComplete}
                    ref={g => grid = g}
                    selectionSettings={{ 
                        persistSelection: true,
                        type: "Multiple",
                        checkboxOnly: true,
                        mode: "Row"}}
                    //rowSelecting={(event: any) => { }}
                    rowSelected={(event: any) => { expandRow(event) }}
                    rowDeselected={(event: any) => { rowDeselect(event) }}
                    allowSelection={true}
                    allowResizing={true}
                    rowHeight={28}
                    rowDataBound={(args : any) => {
                        if (args.row) {
                            if (getValue('FoundJail', args.data)  === 2){
                                args.row.classList.add('red');
                            }
                        }
                    }}
                >
                    <ColumnsDirective>
                        <ColumnDirective field='PersonID' width={140} minWidth={140} maxWidth={140} headerText='Person ID' visible={false} isPrimaryKey={true} />
                        {isNCICShow() ? <ColumnDirective type='checkbox' width='50' customAttributes={{ class: ['e-checkbox-custom'] }} /> : <></>}
                        {/* { isNCICShow() ? <ColumnDirective template={selectTemplate} headerText='Select' width={100} /> : <></>} */}
                        <ColumnDirective field='PercentileDate' width={140} minWidth={140} maxWidth={140} headerText='SCOR Date' format={{ type: 'date', format: 'MM/dd/yyyy' }} customAttributes={{ class: ['e-attr'] }} />
                        <ColumnDirective field='CrumbScore' width={160} minWidth={160} maxWidth={160} headerText='SCOR' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='CrumbScorePercentile' width={180} minWidth={180} maxWidth={180} headerText={`${GetStringNameForSite(SiteName,'SCOR_TBL')}Ranking`} customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='FName' width={140} minWidth={140} maxWidth={140} headerText='First Name' customAttributes={{ class: ['e-attr']}}/>
                        <ColumnDirective field='MName' width={110} minWidth={110} maxWidth={110} headerText='MI' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='LName' width={140} minWidth={140} maxWidth={140} headerText='Last Name' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='DOB' width={115} minWidth={115} maxWidth={115} format={{ type: 'date', format: 'MM/dd/yyyy' }} headerText='DOB'
                            customAttributes={{ class: ['e-attr'] }} />
                        <ColumnDirective field='FBI' width={110} minWidth={110} maxWidth={110} headerText='FBI' customAttributes={{ class: ['e-attr'] }} visible={false}/>
                        <ColumnDirective field='SBINo' width={110} minWidth={110} maxWidth={110} headerText='SBINo' customAttributes={{ class: ['e-attr'] }} visible={false}/>
                        <ColumnDirective field='SSN1' width={110} minWidth={110} maxWidth={110} headerText='SSN' customAttributes={{ class: ['e-attr'] }} visible={false}/>
                        <ColumnDirective field='SEX' width={110} minWidth={110} maxWidth={110} headerText='Sex' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='City' width={140} minWidth={140} maxWidth={140} headerText={`${GetStringNameForSite(SiteName,'CITY')}`} customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='State' width={110} minWidth={110} maxWidth={110} headerText='State' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective template={gridTemplate} maxWidth={300} headerText='Indicator' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='STATUTE' width={140} minWidth={140} maxWidth={140} headerText={`${GetStringNameForSite(SiteName,'STATUTE')}`} customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='STATUTEDESCRIPTION' maxWidth={250} headerText='Description' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='DTOFARREST' width={140} minWidth={140} maxWidth={140} format={{ type: 'date', format: 'MM/dd/yyyy' }} headerText='Arrest Date'
                            customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='DTOFUPDATE' width={135} minWidth={135} maxWidth={135} format={{ type: 'date', format: 'MM/dd/yyyy' }} headerText='Entry Date'
                            customAttributes={{ class: ['e-attr'] }} />
                        <ColumnDirective field='ORIGINATINGORINAME' maxWidth={200} headerText='Agency Arrested' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='Dept' maxWidth={200} headerText='InfoCop Dept' customAttributes={{ class: ['e-attr'] }}/>
                        {showPlate ? <ColumnDirective field='Plate' width={130} minWidth={130} maxWidth={130} headerText='Plate #' customAttributes={{ class: ['e-attr'] }}/> : <></>}
                        <ColumnDirective field='FoundPhoto' width={110} minWidth={110} maxWidth={110} headerText='Found Photo' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundArrest' width={110} minWidth={110} maxWidth={110} headerText='Found Arrest' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundETicket' width={110} minWidth={110} maxWidth={110} headerText='Found ETicket' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundParkMobile' width={110} minWidth={110} maxWidth={110} headerText='Found ParkMobile' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundALPR' width={110} minWidth={110} maxWidth={110} headerText='Found ALPR' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundCADRMS' width={110} minWidth={110} maxWidth={110} headerText='Found CADRMS' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundCODIS' width={110} minWidth={110} maxWidth={110} headerText='Found CODIS' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundPrisonRelease' width={110} minWidth={110} maxWidth={110} headerText='Found Prison Release' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundGunTrace' width={110} minWidth={110} maxWidth={110} headerText='Found Gun Trace' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundShooting' width={110} minWidth={110} maxWidth={110} headerText='Found Shooting' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundNIBIN' width={110} minWidth={110} maxWidth={110} headerText='Found NIBIN' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundNJGunTrace' width={110} minWidth={110} maxWidth={110} headerText='Found NJGunTrace' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundPrisonParole' width={110} minWidth={110} maxWidth={110} headerText='Found Prison/Parole' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundViolent' width={110} minWidth={110} maxWidth={110} headerText='Found Violent' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundHumanTraffic' width={110} minWidth={110} maxWidth={110} headerText='Found Human Traffic' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundProfession' width={110} minWidth={110} maxWidth={110} headerText='Found Profession' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundReferral' width={110} minWidth={110} maxWidth={110} headerText='Found Referral' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundProfile' width={110} minWidth={110} maxWidth={110} headerText='Found Profile' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundDomViolence' width={110} minWidth={110} maxWidth={110} headerText='Found Domestic Violence' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundSexCrime' width={110} minWidth={110} maxWidth={110} headerText='Found Sex Crime' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundCarTheft' width={110} minWidth={110} maxWidth={110} headerText='Found Car Theft' customAttributes={{ class: ['e-attr'] }} visible={false} />
                        <ColumnDirective field='FoundJail' width={110} minWidth={110} maxWidth={110} headerText='Found Jail' customAttributes={{ class: ['e-attr'] }} visible={false} />
                    </ColumnsDirective>
                    <Inject services={[ColumnMenu, Sort, Page, Filter, DetailRow, Toolbar, ExcelExport,PdfExport,Search, Resize, Reorder]}/>
                </GridComponent>

            </>:<></>}
        </div>
    );
};

export default SearchResults;